/**
 * KAN-833: запуск звонка менеджеру с соединением с клиентом. Результат
 * показывается тостом: успех с маской номера менеджера, отказ 400 текстом
 * причины от backend, остальное общей ошибкой.
 * KAN-877: mutate(target) звонит выбранному адресату, mutate() по правилу сервера.
 */
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { CallTargetKind } from '@/services/api/callTargets';
import { startManagerCall, type ManagerCallStarted } from '@/services/api/managerCall';

export const MANAGER_CALL_ERROR = 'Не удалось начать звонок, попробуйте ещё раз';

export function managerCallStartedText(masked: string): string {
  return `Звоним вам на ${masked}, возьмите трубку. Потом соединим с клиентом.`;
}

function failureText(err: unknown): string {
  const response = (err as { response?: { status?: number; data?: unknown } } | null)?.response;
  const detail = (response?.data as { detail?: unknown } | undefined)?.detail;
  if (response?.status === 400 && typeof detail === 'string' && detail !== '') return detail;
  return MANAGER_CALL_ERROR;
}

export function useManagerCall(clientId: string) {
  return useMutation<ManagerCallStarted, unknown, CallTargetKind | void>({
    // Без адресата вызов без второго аргумента: прежний запрос без тела.
    mutationFn: (target) => (target ? startManagerCall(clientId, target) : startManagerCall(clientId)),
    onSuccess: (data) => {
      toast.success(managerCallStartedText(data.manager_phone_masked));
    },
    onError: (err) => {
      toast.error(failureText(err));
    },
  });
}
